// import React, { useEffect, useState } from 'react';
// import { Row, Col, Card, CardBody, Button, Input, Label, FormGroup } from 'reactstrap';
// import WidgetsSectionTitle from '../../../WidgetsSectionTitle/WidgetSectionTitle';
// import { connect } from 'react-redux';
// import { createAgentConfig, fetchAgentConfig, generateAgentPrompt, updateAgentConfig ,deleteAgentConfig, toggleAgentStatus } from '../../../Redux/Actions/AI/aiagent';
// import { toast } from 'react-toastify';

// const AgentConfig = ({ createAgentConfig, fetchAgentConfig, generateAgentPrompt, updateAgentConfig, deleteAgentConfig, toggleAgentStatus }) => {
//   const [form, setForm] = useState({
//   agentName: '',
//   agentJobTitle: '',
//   agentJobDescription: '',
//   companyName: '',
//   greetingMessage: 'Hi! How can I assist you with your real estate needs today?',
//   prompt: ''
// });
// const [initialPrompt, setInitialPrompt] = useState('');
// const [isPromptLoading, setIsPromptLoading] = useState(false);
// const [promptEditable, setPromptEditable] = useState(false);
// const [agentId, setAgentId] = useState(null);
// const [status, setStatus] = useState(false);

// useEffect(() => {
//   fetchAgentConfig().then(res => {
//     if (res) {
//       setForm({
//         agentName: res.agentName || '',
//         agentJobTitle: res.agentJobTitle || '',
//         agentJobDescription: res.agentJobDescription || '',
//         companyName: res.companyName || '',
//         greetingMessage: res.greetingMessage || 'Hi! How can I assist you with your real estate needs today?',
//         prompt: res.prompt || ''
//       });

//       const prompt = res.prompt || '';
//       setInitialPrompt(prompt);
//       setPromptEditable(!!prompt); // enable if prompt exists
//       setAgentId(res._id || null);
//       setStatus(res.status || false); // ✅ set status on initial render
//     }
//   });
// }, []);



//   const handleResetConfig = async () => {
//     const result = await deleteAgentConfig();
//     if (result?.success) {
//       toast.error("AI Agent configuration has been reset successfully.");

//       setForm({
//         agentName: '',
//         agentJobTitle: '',
//         agentJobDescription: '',
//         companyName: '',
//         greetingMessage: 'Hi! How can I assist you with your real estate needs today?',
//         prompt: ''
//       });

//       setInitialPrompt('');
//       setPromptEditable(false);
//       setAgentId(null);
//       setStatus(false);
//     } else {
//       toast.error("Failed to reset configuration. Please try again.");
//     }
//   };



// const handleSave = async () => {
//   if (agentId) {
//     await updateAgentConfig(agentId, form); // ✅ update existing
//   } else {
//     await createAgentConfig(form); // ✅ create new
//   }
//   toast.success('Agent saved successfully');
//   setInitialPrompt(form.prompt);
// };


 

// const handleChange = e => {
//   setForm({ ...form, [e.target.name]: e.target.value });
// };

// const isPromptChanged =
//   promptEditable &&
//   form.prompt.trim() !== '' &&
//   form.prompt.trim() !== initialPrompt.trim();

//   const allFieldsFilled =
//     form.agentName &&
//     form.agentJobTitle &&
//     form.agentJobDescription &&
//     form.companyName &&
//     form.greetingMessage;

//  const handleGeneratePrompt = async () => {
//   setIsPromptLoading(true);
//   const prompt = await generateAgentPrompt(form);
//   if (prompt) {
//     setForm(prev => ({ ...prev, prompt }));
//     setPromptEditable(true); // allow editing
//     setInitialPrompt('');    // clear to treat generated prompt as new
//   }
//   setIsPromptLoading(false);
// };

 


//   return (
//     <Row className="justify-content-center">
//       <Col xs="12">
//         <WidgetsSectionTitle
//           className="my-2"
//           title="Agent Config"
//           subtitle="Set up your AI Agent's role, greeting, and response behavior"
//           icon="user"
//         />
//       </Col>
//       <Col xs="12">
//         <Card>
//           <CardBody>
//             <div className="d-flex justify-content-between align-items-center mb-3 px-2">
//   <h5 className="fw-bold mb-0">AI Live Calling Status :</h5>
//   <div className="form-check form-switch">
//     <input
//       className="form-check-input"
//       type="checkbox"
//       role="switch"
//       id="aiStatusToggle"
//       checked={status}
//       onChange={async () => {
//         const requestedStatus = !status;

//         const result = await toggleAgentStatus(requestedStatus);

//         if (requestedStatus === true && (!result || result.status === false)) {
//           toast.error("❌ Please generate and save a prompt before enabling AI Calling.");
//           setStatus(false); // ensure toggle is off
//           return;
//         }

//         if (result?.status === true) {
//           toast.success("AI Live Calling feature activated.");
//           setStatus(true);
//         } else if (result?.status === false) {
//           toast.error("AI Live Calling feature deactivated.");
//           setStatus(false);
//         } else {
//           toast.error("❌ Something went wrong. Try again.");
//         }
//       }}
//     />
//    <label className="form-check-label ms-2 fw-semibold" htmlFor="aiStatusToggle">
// {status ? '🟢 Live - Assistant is Active' : '🔴 Disabled - Assistant is Off'}
// </label>
//   </div>
// </div>

//             <FormGroup>
//               <Label>Agent Name</Label>
//               <Input
//                 type="text"
//                 placeholder="eg: Luna"
//                 name="agentName"
//                 value={form.agentName}
//                 onChange={handleChange}
//               />
//             </FormGroup>
//             <FormGroup>
//               <Label>Agent Job Role</Label>
//               <Input
//                 type="text"
//                 placeholder="eg: You are a professional and friendly real estate assistant."
//                 name="agentJobTitle"
//                 value={form.agentJobTitle}
//                 onChange={handleChange}
//               />
//             </FormGroup>
//             <FormGroup>
//               <Label>Agent Job Description</Label>
//               <Input
//                 type="textarea"
//                 placeholder="eg: Your job is to help users with buying, selling, or renting homes."
//                 name="agentJobDescription"
//                 value={form.agentJobDescription}
//                 onChange={handleChange}
//               />
//             </FormGroup>
//             <FormGroup>
//               <Label>Company Name</Label>
//               <Input
//                 type="text"
//                 placeholder="eg: ABC PVT LTD"
//                 name="companyName"
//                 value={form.companyName}
//                 onChange={handleChange}
//               />
//             </FormGroup>
//             <FormGroup>
//               <Label>Initial Greeting Message</Label>
//               <Input
//                 type="text"
//                 name="greetingMessage"
//                 value={form.greetingMessage}
//                 onChange={handleChange}
//               />
//             </FormGroup>

//             <Button
//               color="primary"
//               style={{fontSize:"12px"}}
//               disabled={!allFieldsFilled || isPromptLoading}
//               onClick={handleGeneratePrompt}
//             >
//               {isPromptLoading ? 'Generating...' : 'Create Prompt'}
//             </Button>

           




// <FormGroup className="mt-3">
//   <Label>Prompt</Label>
//   <Input
//     type="textarea"
//     placeholder="Generate an AI prompt above to begin..."
//      // style={{ filter: form.prompt.trim() !== '' ? 'none' : 'blur(3px)' }}
//     disabled={!promptEditable}
//     value={form.prompt}
//     onChange={handleChange}
//     name="prompt"
//   />
// </FormGroup>

// <Button
//   disabled={!isPromptChanged}
//   onClick={handleSave}
//               style={{ fontSize: '12px', backgroundColor: '#16A34A', borderColor: '#16A34A', marginRight: 8 }}

// >
//   Save Agent Configuration
// </Button>

// <Button
//   color="danger"
//   style={{fontSize:"12px"}}
//   onClick={handleResetConfig}
// disabled={!form.prompt.trim()}  // ✅ Only enabled when prompt exists
// >
//   Reset Configuration
// </Button>








//           </CardBody>
//         </Card>
//       </Col>
//     </Row>
//   );
// };



// export default connect(null, {
//   createAgentConfig,
//   fetchAgentConfig,
//   generateAgentPrompt,
//   updateAgentConfig, // ✅ include this
//   deleteAgentConfig, // ✅ Add here
//   toggleAgentStatus, // ✅ include this

// })(AgentConfig);





import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Input, Label, FormGroup } from 'reactstrap';
import WidgetsSectionTitle from '../../../WidgetsSectionTitle/WidgetSectionTitle';
import { connect } from 'react-redux';
import { createAgentConfig, fetchAgentConfig, generateAgentPrompt, updateAgentConfig ,deleteAgentConfig, toggleAgentStatus } from '../../../Redux/Actions/AI/aiagent';
import { toast } from 'react-toastify';

// ✅ NEW: AI settings actions
import { fetchAISettings, updateAISettings } from '../../../Redux/Actions/AI/aiSettings';

const AgentConfig = ({
  createAgentConfig,
  fetchAgentConfig,
  generateAgentPrompt,
  updateAgentConfig,
  deleteAgentConfig,
  toggleAgentStatus,

  // ✅ NEW: AI settings from Redux
  ai_sense,
  ai_listen,
  aiSettingsLoading,

  // ✅ NEW: AI settings actions
  fetchAISettings,
  updateAISettings
}) => {
  const [form, setForm] = useState({
    agentName: '',
    agentJobTitle: '',
    agentJobDescription: '',
    companyName: '',
    greetingMessage: 'Hi! How can I assist you with your real estate needs today?',
    prompt: ''
  });
  const [initialPrompt, setInitialPrompt] = useState('');
  const [isPromptLoading, setIsPromptLoading] = useState(false);
  const [promptEditable, setPromptEditable] = useState(false);
  const [agentId, setAgentId] = useState(null);
  const [status, setStatus] = useState(false);

  // ✅ NEW: modal for AI Sense/Listen confirm
  const [modalContent, setModalContent] = useState(null);
  const [pendingAction, setPendingAction] = useState(null); // 'sense-on' | 'sense-off' | 'listen-on' | 'listen-off'

  useEffect(() => {
    // Load Agent config (existing behavior)
    fetchAgentConfig().then(res => {
      if (res) {
        setForm({
          agentName: res.agentName || '',
          agentJobTitle: res.agentJobTitle || '',
          agentJobDescription: res.agentJobDescription || '',
          companyName: res.companyName || '',
          greetingMessage: res.greetingMessage || 'Hi! How can I assist you with your real estate needs today?',
          prompt: res.prompt || ''
        });

        const prompt = res.prompt || '';
        setInitialPrompt(prompt);
        setPromptEditable(!!prompt);
        setAgentId(res._id || null);
        setStatus(res.status || false);
      }
    });

    // ✅ Load AI Sense/Listen
    fetchAISettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResetConfig = async () => {
    const result = await deleteAgentConfig();
    if (result?.success) {
      toast.error("AI Agent configuration has been reset successfully.");

      setForm({
        agentName: '',
        agentJobTitle: '',
        agentJobDescription: '',
        companyName: '',
        greetingMessage: 'Hi! How can I assist you with your real estate needs today?',
        prompt: ''
      });

      setInitialPrompt('');
      setPromptEditable(false);
      setAgentId(null);
      setStatus(false);
    } else {
      toast.error("Failed to reset configuration. Please try again.");
    }
  };

  const handleSave = async () => {
    if (agentId) {
      await updateAgentConfig(agentId, form);
    } else {
      await createAgentConfig(form);
    }
    toast.success('Agent saved successfully');
    setInitialPrompt(form.prompt);
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isPromptChanged =
    promptEditable &&
    form.prompt.trim() !== '' &&
    form.prompt.trim() !== initialPrompt.trim();

  const allFieldsFilled =
    form.agentName &&
    form.agentJobTitle &&
    form.agentJobDescription &&
    form.companyName &&
    form.greetingMessage;

  const handleGeneratePrompt = async () => {
    setIsPromptLoading(true);
    const prompt = await generateAgentPrompt(form);
    if (prompt) {
      setForm(prev => ({ ...prev, prompt }));
      setPromptEditable(true);
      setInitialPrompt('');
    }
    setIsPromptLoading(false);
  };

  // ===========================
  // ✅ NEW: AI Sense/Listen UX
  // ===========================
  const senseBtnClass = ai_sense ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm';
  const senseLabel = ai_sense ? 'AI Sense: On' : 'AI Sense: Off';

  const onClickToggleSense = () => {
    if (ai_sense) {
      setPendingAction('sense-off');
      setModalContent('You are about to turn OFF AI Sense. This will also stop AI Listen from monitoring Conversations & AI Live Calls. Do you want to continue?');
    } else {
      setPendingAction('sense-on');
      setModalContent('You are about to turn ON AI Sense. This will also enable AI Listen to start monitoring Conversations & AI Live Calls. Proceed?');
    }
  };

  const onToggleListen = () => {
    if (!ai_sense || aiSettingsLoading) return;
    if (ai_listen) {
      setPendingAction('listen-off');
      setModalContent('AI Listen will stop monitoring Conversations & AI Live Calls. Do you want to turn it OFF?');
    } else {
      setPendingAction('listen-on');
      setModalContent('AI Listen will start monitoring Conversations & AI Live Calls. Do you want to turn it ON?');
    }
  };

  const closeModal = () => {
    setModalContent(null);
    setPendingAction(null);
  };

  const confirmModal = async () => {
    try {
      if (pendingAction === 'sense-off') {
        await updateAISettings({ ai_sense: false, ai_listen: false });
        toast.info('AI Sense disabled. AI Listen has been turned off.');
      } else if (pendingAction === 'sense-on') {
        await updateAISettings({ ai_sense: true, ai_listen: true });
        toast.success('AI Sense enabled. AI Listen is now active.');
      } else if (pendingAction === 'listen-off') {
        await updateAISettings({ ai_listen: false });
        toast.info('AI Listen turned off.');
      } else if (pendingAction === 'listen-on') {
        await updateAISettings({ ai_listen: true });
        toast.success('AI Listen turned on.');
      }
    } finally {
      closeModal();
    }
  };

  return (
    <Row className="justify-content-center">
      <Col xs="12">
        <WidgetsSectionTitle
          className="my-2"
          title="Agent Config"
          subtitle="Set up your AI Agent's role, greeting, and response behavior"
          icon="user"
        />
      </Col>
      <Col xs="12">
        <Card>
          <CardBody>
            {/* ======== Existing Live Calling ======== */}
            {/* <div className="d-flex  align-items-center mb-3 px-2">
              <h5 className="fw-bold mb-0">AI Live Calling Status :</h5>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="aiStatusToggle"
                  checked={status}
                  onChange={async () => {
                    const requestedStatus = !status;
                    const result = await toggleAgentStatus(requestedStatus);

                    if (requestedStatus === true && (!result || result.status === false)) {
                      toast.error("❌ Please generate and save a prompt before enabling AI Calling.");
                      setStatus(false);
                      return;
                    }

                    if (result?.status === true) {
                      toast.success("AI Live Calling feature activated.");
                      setStatus(true);
                    } else if (result?.status === false) {
                      toast.error("AI Live Calling feature deactivated.");
                      setStatus(false);
                    } else {
                      toast.error("❌ Something went wrong. Try again.");
                    }
                  }}
                />
                <label className="form-check-label ms-2 fw-semibold" htmlFor="aiStatusToggle">
                  {status ? '🟢 Live - Assistant is Active' : '🔴 Disabled - Assistant is Off'}
                </label>
              </div>
            </div> */}

            {/* ======== AI Live Calling (same logic, new UI) ======== */}
<div className="d-flex justify-content-between align-items-center mb-2 px-2">
  <h5 className="fw-bold mb-0">AI Live Calling Status :</h5>
</div>

<div className="ai-live-wrap px-2 py-3 mb-4 rounded-3 border" style={{ background: '#f8fafc', borderColor: '#e5e7eb' }}>
  <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
    {/* Left: Switch + label (logic unchanged) */}
    {/* <div className="d-inline-flex align-items-center ai-live-controls">
      <div className="form-check form-switch m-0 ai-live-switch">
        <input
          className="form-check-input position-static"
          type="checkbox"
          role="switch"
          id="aiStatusToggle"
          checked={status}
          onChange={async () => {
            const requestedStatus = !status;
            const result = await toggleAgentStatus(requestedStatus);

            if (requestedStatus === true && (!result || result.status === false)) {
              toast.error("❌ Please generate and save a prompt before enabling AI Calling.");
              setStatus(false);
              return;
            }

            if (result?.status === true) {
              toast.success("AI Live Calling feature activated.");
              setStatus(true);
            } else if (result?.status === false) {
              toast.error("AI Live Calling feature deactivated.");
              setStatus(false);
            } else {
              toast.error("❌ Something went wrong. Try again.");
            }
          }}
          style={{ width: 44, height: 24 }}
        />
        <label className="form-check-label fw-semibold mb-0 ms-2" htmlFor="aiStatusToggle">
          {status ? '🟢 Live - Assistant is Active' : '🔴 Disabled - Assistant is Off'}
        </label>
      </div>
    </div> */}

  <div className="d-inline-flex align-items-center ai-live-controls">
  <div className="form-check form-switch m-0 ai-live-switch">
    <input
      className="form-check-input"
      type="checkbox"
      role="switch"
      id="aiStatusToggle"
      checked={status}
      onChange={async () => {
        const requestedStatus = !status;
        const result = await toggleAgentStatus(requestedStatus);

        if (requestedStatus === true && (!result || result.status === false)) {
          toast.error("❌ Please generate and save a prompt before enabling AI Calling.");
          setStatus(false);
          return;
        }

        if (result?.status === true) {
          toast.success("AI Live Calling feature activated.");
          setStatus(true);
        } else if (result?.status === false) {
          toast.error("AI Live Calling feature deactivated.");
          setStatus(false);
        } else {
          toast.error("❌ Something went wrong. Try again.");
        }
      }}
      style={{ width: 44, height: 24 }}
    />
    {/* add ai-live-label */}
    <label className="form-check-label ai-live-label mb-0" htmlFor="aiStatusToggle">
      {status ? '🟢 Live - Assistant is Active' : '🔴 Disabled - Assistant is Off'}
    </label>
  </div>
</div>



    {/* Right: Tip */}
    <div className="text-muted small ai-tip">
      <span className="me-1">Tip:</span>
      <span>
        Enable when your prompt is ready so calls are answered by your assistant. Turn it off to pause live handling instantly.
      </span>
    </div>
  </div>
</div>


            {/* =========================
                ✅ NEW: AI Sense / Listen
                ========================= */}
            {/* <div className="px-2 py-3 mb-4 rounded-3 border" style={{ background: '#f8fafc', borderColor: '#e5e7eb' }}>
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div className="d-flex align-items-center gap-2">
                  <div
                    className={`${senseBtnClass} ai-sense-pill`}
                    onClick={onClickToggleSense}
                    role="button"
                    aria-label="Toggle AI Sense"
                    title="Toggle AI Sense"
                    style={{ minWidth: 132, textAlign: 'center' }}
                  >
                    {senseLabel}
                  </div>

                  <div className="ms-3 d-flex align-items-center">
                    <input
                      id="aiListenChk"
                      type="checkbox"
                      className="form-check-input"
                      style={{ width: 18, height: 18, cursor: ai_sense ? 'pointer' : 'not-allowed' }}
                      checked={!!ai_listen && !!ai_sense}
                      disabled={!ai_sense || aiSettingsLoading}
                      onChange={onToggleListen}
                    />
                    <label htmlFor="aiListenChk" className="ms-2 fw-semibold" style={{ fontSize: 13, opacity: ai_sense ? 1 : 0.6 }}>
                      AI Listen
                    </label>
                  </div>
                </div>

                <div className="text-muted small">
                  <span className="me-2">Tip:</span>
                  <span>
                    AI Listen is available only when <strong>AI Sense</strong> is active. Switching Sense off disables Listen automatically.
                  </span>
                </div>
              </div>
            </div> */}

            {/* =========================
    ✅ NEW: AI Sense / Listen (fixed)
    ========================= */}
<div className="d-flex justify-content-between align-items-center mb-2 px-2">
  <h5 className="fw-bold mb-0">AI Sense Status:</h5>
</div>

<div className="ai-sense-wrap px-2 py-3 mb-4 rounded-3 border" style={{ background: '#f8fafc', borderColor: '#e5e7eb' }}>
  <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
    {/* Left: Controls */}
    <div className="d-inline-flex flex-wrap align-items-center ai-sense-controls">
      <div
        className={`${senseBtnClass} ai-sense-pill`}
        onClick={onClickToggleSense}
        role="button"
        aria-label="Toggle AI Sense"
        title="Toggle AI Sense"
      >
        {senseLabel}
      </div>

      <div className="form-check m-0 ai-listen-check">
        <input
          id="aiListenChk"
          type="checkbox"
          className="form-check-input position-static"
          checked={!!ai_listen && !!ai_sense}
          disabled={!ai_sense || aiSettingsLoading}
          onChange={onToggleListen}
        />
        <label htmlFor="aiListenChk" className="form-check-label fw-semibold mb-0">
          AI Listen
        </label>
      </div>
    </div>

    {/* Right: Tip */}
    <div className="text-muted small ai-tip">
      <span className="me-1">Tip:</span>
      <span>
        AI Listen is available only when <strong>AI Sense</strong> is active. AI Listen monitors Conversations and AI live calls, providing actionable insights to the user.
      </span>
    </div>
  </div>
</div>


            {/* ======== Existing Form ======== */}
            <FormGroup>
              <Label>Agent Name</Label>
              <Input
                type="text"
                placeholder="eg: Luna"
                name="agentName"
                value={form.agentName}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Agent Job Role</Label>
              <Input
                type="text"
                placeholder="eg: You are a professional and friendly real estate assistant."
                name="agentJobTitle"
                value={form.agentJobTitle}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Agent Job Description</Label>
              <Input
                type="textarea"
                placeholder="eg: Your job is to help users with buying, selling, or renting homes."
                name="agentJobDescription"
                value={form.agentJobDescription}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Company Name</Label>
              <Input
                type="text"
                placeholder="eg: ABC PVT LTD"
                name="companyName"
                value={form.companyName}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Initial Greeting Message</Label>
              <Input
                type="text"
                name="greetingMessage"
                value={form.greetingMessage}
                onChange={handleChange}
              />
            </FormGroup>

            <Button
              color="primary"
              style={{fontSize:"12px"}}
              disabled={!allFieldsFilled || isPromptLoading}
              onClick={handleGeneratePrompt}
            >
              {isPromptLoading ? 'Generating...' : 'Create Prompt'}
            </Button>

            <FormGroup className="mt-3">
              <Label>Prompt</Label>
              <Input
                type="textarea"
                placeholder="Generate an AI prompt above to begin..."
                disabled={!promptEditable}
                value={form.prompt}
                onChange={handleChange}
                name="prompt"
              />
            </FormGroup>

            <Button
              disabled={!isPromptChanged}
              onClick={handleSave}
              style={{ fontSize: '12px', backgroundColor: '#16A34A', borderColor: '#16A34A', marginRight: 8 }}
            >
              Save Agent Configuration
            </Button>

            <Button
              color="danger"
              style={{fontSize:"12px"}}
              onClick={handleResetConfig}
              disabled={!form.prompt.trim()}
            >
              Reset Configuration
            </Button>

            {/* ===== Modal for AI Sense/Listen ===== */}
            {modalContent && (
              <div className="modal-backdrop" onClick={closeModal}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                  <p style={{ fontSize: '16px', marginBottom: 0 }}>{modalContent}</p>
                  <div className="d-flex justify-content-center mt-3" style={{ gap: 12 }}>
                    <button onClick={confirmModal} className="btn btn-primary btn-sm" style={{ fontSize: '16px' }}>
                      Confirm
                    </button>
                    <button onClick={closeModal} className="btn btn-outline-secondary btn-sm" style={{ fontSize: '16px' }}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Local styles to match your theme and elevate the new UI */}
            <style jsx>{`

            /* Transparent backdrop (no grey/blur), still centers the modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: transparent !important;  /* ← no tint */
  opacity: 1 !important;               /* ensure fully visible but transparent */
  backdrop-filter: none !important;     /* no blur */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

/* If Bootstrap’s global .modal-backdrop exists, this ensures transparency too */
:global(.modal-backdrop.show) {
  background-color: transparent !important;
  opacity: 1 !important;
  backdrop-filter: none !important;
}

         
              .modal-content {
                background: #ffffff;
                padding: 20px 22px;
                border-radius: 12px;
                box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);
                text-align: center;
                max-width: 560px;
                width: 100%;
              }
        
           
              .ai-sense-wrap { }
.ai-sense-controls {
  gap: 12px;           /* space between pill and checkbox */
}
.ai-listen-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;            /* space between checkbox and label */
}
.ai-listen-check .form-check-input.position-static {
  /* neutralize bootstrap’s default negative margins that caused overlap */
  margin: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.ai-sense-pill {
  border-radius: 999px;
  padding: 6px 14px;
  min-width: 132px;
  text-align: center;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  transition: transform .05s ease, box-shadow .15s ease;
  user-select: none;
}
.ai-sense-pill:active {
  transform: translateY(1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
.ai-tip { max-width: 60ch; }

/* Responsive nicety: stack gracefully on narrow screens */
@media (max-width: 576px) {
  .ai-tip { margin-top: 10px; }
}

/* Keep the whole left cluster in one line & centered */
.ai-live-controls {
  gap: 10px;
}

/* Make the switch + label align perfectly */
.ai-live-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;               /* space between switch and text */
}

/* Neutralize Bootstrap switch offsets and lock vertical centering */
.ai-live-switch .form-check-input {
  margin: 0 !important;   /* remove default negative top margin */
  vertical-align: middle;
  width: 44px;
  height: 24px;
}

/* Match label height to switch height and center content */
.ai-live-switch .form-check-label {
  margin: 0;
  line-height: 24px;      /* same as switch height for vertical alignment */
  display: flex;
  align-items: center;
}

/* Keep the left cluster aligned and spaced */
.ai-live-controls { gap: 10px; }

/* Make the switch + label a clean inline row */
.ai-live-switch {
  display: inline-flex;
  align-items: center;
}

/* Neutralize Bootstrap’s offsets and add explicit gap */
.ai-live-switch.form-switch { padding-left: 0; }
.ai-live-switch .form-check-input {
  margin: 0 !important;             /* remove default negative margins */
  margin-right: 10px !important;    /* ← space between checkbox and text */
  vertical-align: middle;
  width: 44px;
  height: 24px;
}

/* Ensure label never slides under the input */
.ai-live-label {
  display: inline-flex;
  align-items: center;
  line-height: 24px;                 /* match switch height */
}

.ai-live-switch.form-switch {
  padding-left: 2.75rem !important; /* default ~2.5rem; a touch more space looks nicer */
}

/* Put the switch back to its normal left offset and add a small gap */
.ai-live-switch.form-switch .form-check-input {
  margin-left: -2.75rem !important; /* pair with the container padding above */
  margin-right: .5rem !important;   /* gap before the label */
  width: 44px;
  height: 24px;
  vertical-align: middle;
}

/* Keep label aligned and on the same baseline */
.ai-live-label,
.ai-live-switch .form-check-label {
  display: inline-flex;
  align-items: center;
  line-height: 24px; /* match switch height */
  margin: 0;
}

/* Ensure the left cluster is a single centered row with spacing */
.ai-live-controls {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

            `}</style>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

const mapStateToProps = state => ({
  // ✅ pull from aiSettings slice
  ai_sense: state.aiSettings.ai_sense,
  ai_listen: state.aiSettings.ai_listen,
  aiSettingsLoading: state.aiSettings.loading
});

export default connect(mapStateToProps, {
  createAgentConfig,
  fetchAgentConfig,
  generateAgentPrompt,
  updateAgentConfig,
  deleteAgentConfig,
  toggleAgentStatus,

  // ✅ NEW
  fetchAISettings,
  updateAISettings
})(AgentConfig);
